import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../services/config";
import { useAlert } from "react-alert";
import { Field, useFormik, Form, Formik } from "formik";
import * as Yup from "yup";
import { Alert } from "react-bootstrap";
import { Input } from "../../../../_metronic/_partials/controls";

const EditDefineSallary = ({ staffDetails, show, reload }) => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");

  const [loading, setloading] = useState(false);
  const [isPreviewEnable, setisPreviewEnable] = useState(false);
  const [previewValue, setpreviewValue] = useState({});

  const [bankList, setbankList] = useState([]);
  const [showerr, setshowerr] = useState(false);
  const [showerror, setshowerror] = useState("Please Fill all Fields");

  const [allsubaccounts, setallsubaccounts] = useState([]);
  const [selectedBankCateogry, setSelectedBankCateogry] = useState(
    staffDetails.bank_account_id,
  );
  const [selectedBank, setSelectedBank] = useState("");
  const [resetCheck, setResetCheck] = useState(false);

  let initialValues = {
    issubmitted: false,

    basic: staffDetails.basic_pay,
    salary_month: staffDetails.salary_month,
    id: staffDetails.id,
    dpt_allowance: staffDetails.dpt_allowance,

    hostel: staffDetails.hostel,
    college: staffDetails.college,
    additional_allowance: staffDetails.additional_allowance,
    increment: staffDetails.increment,

    second_shift: staffDetails.second_shift,
    adp_allowance: staffDetails.adp_allowance,
    intermediate_allowance: staffDetails.intermediate_allowance,
    navttc_allowance: staffDetails.navttc_allowance,

    bs_allowance: staffDetails.bs_allowance,
    extra_period: staffDetails.extra_period,
    invigilator_duty_allowance: staffDetails.invigilator_duty_allowance,
    convance: staffDetails.convance,

    eobi: staffDetails.eobi,
    eobi_payments: staffDetails.eobi_payments,
    income_tax: staffDetails.income_tax,
    insurance: staffDetails.insurance,
    van_charge: staffDetails.van_charge,
    other: staffDetails.other,
    other_deduction: staffDetails.other_deduction,
    gp_fund: staffDetails.gp_fund,
    gpf_return: staffDetails.gpf_return,
    welfare_fund: staffDetails.welfare_fund,
    days: staffDetails.days,
    child_fee_deduction: staffDetails.child_fee_deduction,
    loan_refund: staffDetails.loan_refund,
    reset: resetCheck,
  };

  useEffect(() => {
    getAllBankList();
  }, []);

  const getAllBankList = () => {
    fetch(`${baseUrl}/bank_account_category`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setbankList(data.payload);

        let mainBank = 0;

        if (selectedBankCateogry ?? false) {
          data.payload.map((item, index) => {
            item.bank_accounts.map((subitem, index) => {
              if (subitem.id == selectedBankCateogry) {
                setSelectedBank(subitem.bank_account_category_id);
                mainBank = subitem.bank_account_category_id;
              }
            });
          });
        }

        if (mainBank != 0) {
          let bankData = data.payload.filter((item) => item.id == mainBank);

          if (bankData.length != 0) {
            setallsubaccounts([...bankData[0].bank_accounts]);
            // setallsubaccounts(initialValues.bank_account_id);
          } else {
            setallsubaccounts([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateHandler = (values) => {
    setloading(true);
    const data = {
      // designation_id: parseInt(values.designation_id),
      id: staffDetails.id,
      // salary_month:values.salary_month,
      basic_pay: values.basic == "" ? 0 : parseInt(values.basic),
      dpt_allowance: values.dpt_allowance,
      hostel: values.hostel,
      college: values.college,
      additional_allowance: values.additional_allowance,
      increment: values.increment,
      second_shift:
        values.second_shift == "" ? 0 : parseInt(values.second_shift),
      adp_allowance:
        values.adp_allowance == "" ? 0 : parseInt(values.adp_allowance),
      navttc_allowance: values.navttc_allowance,
      intermediate_allowance:
        values.intermediate_allowance == ""
          ? 0
          : parseInt(values.intermediate_allowance),
      bs_allowance:
        values.bs_allowance == "" ? 0 : parseInt(values.bs_allowance),
      extra_period:
        values.extra_period == "" ? 0 : parseInt(values.extra_period),
      invigilator_duty_allowance:
        values.invigilator_duty_allowance == ""
          ? 0
          : parseInt(values.invigilator_duty_allowance),
      convance: values.convance == "" ? 0 : parseInt(values.convance),
      eobi: values.eobi == "" ? 0 : parseInt(values.eobi),
      eobi_payments:
        values.eobi_payments == "" ? 0 : parseInt(values.eobi_payments),
      income_tax: values.income_tax == "" ? 0 : parseInt(values.income_tax),
      insurance: values.insurance == "" ? 0 : parseInt(values.insurance),
      van_charge: values.van_charge == "" ? 0 : parseInt(values.van_charge),
      other: values.other,
      other_deduction: values.other_deduction,
      gp_fund: values.gp_fund,
      gpf_return: parseInt(values.gpf_return),
      welfare_fund: values.welfare_fund,
      days: values.days,
      child_fee_deduction: parseInt(values.child_fee_deduction),
      loan_refund: values.loan_refund,
      preview: 0,
      bank_account_id: parseInt(selectedBankCateogry),
      reset: resetCheck == false ? 0 : 1,
    };

    fetch(`${baseUrl}/employee-salary-update`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          setloading(false);
          show(false);
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Salary Updated Successfully");
              setloading(false);
              show(false);
              reload();
            } else {
              show(false);
              setloading(false);
              const msgArray = Object.values(data.metadata.message);
              msgArray.map((err) => alert.error(err[0]));
            }
          } else {
            show(false);
            setloading(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        alert.error(err);
        show(false);
      });
  };

  //start here

  const AppointStaffSchema = Yup.object().shape({
    dpt_allowance: Yup.string()
      .notRequired("DPT Allowance  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    basic: Yup.string()
      .notRequired("Basic Pay Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    hostel: Yup.string()
      .notRequired("Hostel Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    college: Yup.string()
      .notRequired("College is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    additional_allowance: Yup.string()
      .notRequired("Additional Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    increment: Yup.string()
      .notRequired("Increment  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    second_shift: Yup.string()
      .notRequired("Second Shift Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    adp_allowance: Yup.string()
      .notRequired("ADP Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),

    navttc_allowance: Yup.string()
      .notRequired("Navttc Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),

    intermediate_allowance: Yup.string()
      .notRequired("Intermediate Allowance Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    bs_allowance: Yup.string()
      .notRequired("BS Allowance Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    extra_period: Yup.string()
      .notRequired("Extra Period is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    invigilator_duty_allowance: Yup.string()
      .notRequired("Invigilator Duty Allowance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    convance: Yup.string()
      .notRequired("Convance  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    eobi: Yup.string()
      .notRequired("EOBI Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    eobi_payments: Yup.string()
      .notRequired("eobi payments Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    income_tax: Yup.string()
      .notRequired("Income Tax is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    insurance: Yup.string()
      .notRequired("Insurance is notRequired ")
      .matches(/^[0-9\b]+$/, "Should be number"),
    van_charge: Yup.string()
      .notRequired("Van Charge  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    other: Yup.string()
      .notRequired("other  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),

    welfare_fund: Yup.string()
      .notRequired("Welfare Fund  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    other_deduction: Yup.string()
      .notRequired("Other Detuction  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    gp_fund: Yup.string()
      .notRequired("GP Fund  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    gpf_return: Yup.string()
      .notRequired("GP Fund Return  Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    child_fee_deduction: Yup.string()
      .notRequired("child fee deduction Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
    loan_refund: Yup.string()
      .notRequired("Loan Refund Is notRequired")
      .matches(/^[0-9\b]+$/, "Should be number"),
  });

  // const createEroors = (errors, touched, isSubmitting, values) => {
  //   setshowerr(false);
  //   if (Object.keys(errors).length === 0) {
  //     if (isSubmitting) {
  //       if (!values.issubmitted) {
  //         values.issubmitted = true;
  //         updateHandler(values);
  //       }
  //     }
  //   }
  // };

  const previewHandle = (values) => {
    setisPreviewEnable(true);

    const data = {
      id: staffDetails.id,
      basic_pay: values.basic == "" ? 0 : parseInt(values.basic),
      dpt_allowance: values.dpt_allowance,
      hostel: values.hostel,
      college: values.college,
      additional_allowance: values.additional_allowance,
      increment: values.increment,
      second_shift:
        values.second_shift == "" ? 0 : parseInt(values.second_shift),
      adp_allowance:
        values.adp_allowance == "" ? 0 : parseInt(values.adp_allowance),
      navttc_allowance: values.navttc_allowance,
      intermediate_allowance:
        values.intermediate_allowance == ""
          ? 0
          : parseInt(values.intermediate_allowance),
      bs_allowance:
        values.bs_allowance == "" ? 0 : parseInt(values.bs_allowance),
      extra_period:
        values.extra_period == "" ? 0 : parseInt(values.extra_period),
      invigilator_duty_allowance:
        values.invigilator_duty_allowance == ""
          ? 0
          : parseInt(values.invigilator_duty_allowance),
      convance: values.convance == "" ? 0 : parseInt(values.convance),
      eobi: values.eobi == "" ? 0 : parseInt(values.eobi),
      eobi_payments:
        values.eobi_payments == "" ? 0 : parseInt(values.eobi_payments),
      income_tax: values.income_tax == "" ? 0 : parseInt(values.income_tax),
      insurance: values.insurance == "" ? 0 : parseInt(values.insurance),
      van_charge: values.van_charge == "" ? 0 : parseInt(values.van_charge),
      other: values.other,
      other_deduction: values.other_deduction,
      gp_fund: values.gp_fund,
      gpf_return: values.gpf_return,
      welfare_fund: values.welfare_fund,
      days: values.days,
      child_fee_deduction: values.child_fee_deduction,
      loan_refund: values.loan_refund,
      preview: 1,
      bank_account_id: parseInt(selectedBankCateogry),
      reset: resetCheck == false ? 0 : 1,
    };

    fetch(`${baseUrl}/employee-salary-update`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          const obj = {
            net_pay: data.payload.net_pay,
            gross_salary: data.payload.gross_salary,
          };
          setpreviewValue(obj);
        });
      })
      .catch((err) => {
        console.log(err);
        alert.error(err);
        show(false);
      });
  };

  return (
    <div>
      {loading ? (
        <b style={{ color: "green" }}>
          Salary updating Please Wait <span className="spinner-borderd"></span>
        </b>
      ) : (
        <div>
          <div className="container-fluid">
            <div className="row d-flex justify-content-center ">
              <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                <div>
                  <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={AppointStaffSchema}
                    onSubmit={(values) => {
                      updateHandler(values);
                    }}
                  >
                    {(props) => {
                      const {
                        handleSubmit,
                        errors,
                        touched,
                        values,
                        isSubmitting,
                        isValid,
                        handleChange,
                        handleBlur,
                      } = props;

                      // setErrorsLis(errors)
                      // createEroors(errors, touched, isSubmitting, values);

                      return (
                        <>
                          <Form
                            onSubmit={handleSubmit}
                            className="form form-label-right"
                          >
                            <h3 className="m-3"> Salary Allowance</h3>
                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Basic Salary
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="basic"
                                  component={Input}
                                  placeholder="Basic Salary"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    DPT Allowance
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="dpt_allowance"
                                  component={Input}
                                  placeholder="DPT Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Hostel{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="hostel"
                                  component={Input}
                                  placeholder="Hostel"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    College
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="college"
                                  component={Input}
                                  placeholder="College"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Additional{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="additional_allowance"
                                  component={Input}
                                  placeholder="Additional Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Increment
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="increment"
                                  component={Input}
                                  placeholder="increment"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Second Shift
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="second_shift"
                                  component={Input}
                                  placeholder="Second Shift"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    ADP Allowance
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="adp_allowance"
                                  component={Input}
                                  placeholder="ADP Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Intermediate Allowance
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="intermediate_allowance"
                                  component={Input}
                                  placeholder="Intermediate Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Navttc allowance{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="navttc_allowance"
                                  component={Input}
                                  placeholder="Navttc Allowance"
                                />
                              </div>

                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    BS Allowance{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="bs_allowance"
                                  component={Input}
                                  placeholder="BS Allowance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Extra Period{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="extra_period"
                                  component={Input}
                                  placeholder="Extra Period"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Invigilator Duty
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="invigilator_duty_allowance"
                                  component={Input}
                                  placeholder="Invigilator Duty"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Convance
                                    <span style={{ color: "red" }}>*</span> (No
                                    Effect by Days)
                                  </b>
                                </label>
                                <Field
                                  name="convance"
                                  component={Input}
                                  placeholder="Convance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Days <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="days"
                                  component={Input}
                                  placeholder="Enter Days"
                                />
                              </div>
                            </div>

                            <h3 className="m-3">Salary Deduction Details</h3>

                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    E O B I{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="eobi"
                                  component={Input}
                                  placeholder="EOBI"
                                />
                                {/* <input
                                                                        onChange={(e) => seteobi(e.target.value)}
                                                                        type="text"
                                                                        className="form-control placeholder-bg mb-2"
                                                                    /> */}
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    E O B I Payments{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="eobi_payments"
                                  component={Input}
                                  placeholder="EOBI Payments"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Income Tax{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="income_tax"
                                  component={Input}
                                  placeholder="Income Tax"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Van Charge{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <Field
                                  name="van_charge"
                                  component={Input}
                                  placeholder="Van Charge"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Insurance{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="insurance"
                                  component={Input}
                                  placeholder="Insurance"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Gp Fund{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="gp_fund"
                                  component={Input}
                                  placeholder="Gp Fund"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Gp Fund Return{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="gpf_return"
                                  component={Input}
                                  placeholder="Gp Fund Return"
                                />
                              </div>

                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Welfare Fund{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="welfare_fund"
                                  component={Input}
                                  placeholder="Welfare Fund"
                                />
                              </div>

                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Other Detuction{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="other_deduction"
                                  component={Input}
                                  placeholder="Other Deduction"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Child Fee Deduction{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="child_fee_deduction"
                                  component={Input}
                                  placeholder="Child Fee Deduction"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Loan Refund{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </b>
                                </label>
                                <Field
                                  name="loan_refund"
                                  component={Input}
                                  placeholder="Loan Refund"
                                />
                              </div>
                              <div className="form-group col-sm-4 flex-column d-flex"></div>
                            </div>

                            <div className="row justify-content-between text-left">
                              <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Select Bank
                                    <span
                                      style={{ color: "red", fontSize: 12 }}
                                    >
                                      *
                                    </span>
                                  </b>
                                </label>
                                <select
                                  className="form-select form-control"
                                  name="sub_account_id"
                                  value={selectedBank}
                                  onChange={(e) => {
                                    setSelectedBank(e.target.value);

                                    let bankData = bankList.filter(
                                      (item) => item.id == e.target.value,
                                    );

                                    if (bankData.length != 0) {
                                      setallsubaccounts([
                                        ...bankData[0].bank_accounts,
                                      ]);
                                    } else {
                                      setallsubaccounts([]);
                                    }
                                  }}
                                  style={{ backgroundColor: "white" }}
                                  aria-label="Default select example"
                                >
                                  <option value="">Select...</option>
                                  {bankList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.title}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                  <b>
                                    Select Bank Branch
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <select
                                  className="form-select form-control"
                                  name="sub_account_id"
                                  value={selectedBankCateogry}
                                  onChange={(e) => {
                                    setSelectedBankCateogry(e.target.value);
                                    // setfeerecevingbank(e.target.value);
                                  }}
                                  style={{ backgroundColor: "white" }}
                                  aria-label="Default select example"
                                >
                                  <option value="">Select...</option>
                                  {allsubaccounts.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.bank_name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </Form>
                          {isPreviewEnable ? (
                            <div className="row m-3">
                              <h4>Net Pay: {previewValue.net_pay}</h4>
                              <h4>Gross Salary: {previewValue.gross_salary}</h4>
                            </div>
                          ) : null}
                          {showerr ? (
                            <div id="err">
                              <Alert
                                variant="danger"
                                onClose={() => setshowerr(false)}
                                dismissible
                              >
                                <Alert.Heading>
                                  Oops You Got an Error!
                                </Alert.Heading>
                                <p>{showerror}</p>
                              </Alert>
                            </div>
                          ) : null}
                          <div className="row justify-content-between mb-4">
                            <div className="col-md-6">
                              <button
                                type="submit"
                                value="Submit"
                                onClick={() => previewHandle(values)}
                                className="btn btn-primary pl-4 pr-4"
                              >
                                Preview Salary
                              </button>
                            </div>
                            <div className="col-md-6">
                              <label className="checkbox checkbox-single">
                                <input
                                  name="reset_checkbox"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setResetCheck(e.target.checked)
                                  }
                                />
                                <span />
                                &nbsp;&nbsp;&nbsp;Reset Salary to Defined Actual
                                Amount
                              </label>
                            </div>
                          </div>
                          <div className="btns flex_last">
                            <button
                              type="submit"
                              value="Submit"
                              onClick={() => handleSubmit()}
                              //   onClick={updateHandler}
                              className="btn btn-success button_blue pl-4 pr-4"
                            >
                              Update Salary
                            </button>
                            <button
                              onClick={() => show(false)}
                              className="btn_padding_left btn btn-danger btn_width  pl-4 pr-4 ml-3"
                            >
                              Cancel
                            </button>
                          </div>
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditDefineSallary;
